module.exports = __webpack_public_path__ + "static/media/Pastel de chocolate.5dbce98d.jpg";